import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  logout: ["data"],
  updateAuthTokens: ["accessToken", "refreshToken"],
  setUser: ["user"],
  onLoginSuccess: ["data"],
});

export const AuthTypes = Types;
export default Creators;
